{
  "salon-booking-config-page": {
    "buttons": {
      "book": "REZERVOVAT"
    },
    "text": {
      "black-listed": "Možnost online rezervace v tomto salonu je zablokována. Pro rezervaci nové schůzky kontaktujte salon",
      "not-found-available-time": "Pokud nemůžete najít požadovaný čas, zavolejte nám na telefonní číslo"
    }
  }
}
